module.exports = __webpack_public_path__ + "static/media/18.09a4f040.mp3";